<template>
  <v-dialog
    v-model="createDialog"
    persistent
    max-width="600px"
  >
  
    <v-card style="padding:50px;">
      <v-card-title>
        <span class="headline">{{modalTitle}}</span>
        <v-spacer></v-spacer>
        <v-icon @click="showModal = false">fa fa-times</v-icon>
      </v-card-title>
      <v-text-field 
        label="Book First Name"
        v-model="newBookFirstName"
      ></v-text-field>
      <v-text-field
        label="Another Last Name"
        v-model="newBookLastName"
      ></v-text-field>

      <v-btn small @click="createNewBook()" color="primary">Save</v-btn>
    </v-card>


    <v-snackbar v-model="snackbar" :timeout="5000">
      {{ "Sucessfully created! " }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import * as API from "./../../api";
export default {
  name: "CreateDialog",
  props: ["createDialog", "title", "description", "id", 'modalTitle'],
  data() {
    return {
      newBookTitle: this.title,
      newBookDescription: this.description,
      showModal: true,
      snackbar: false
    };
  },
  methods: {
    createNewBook() {
      this.$api
        .post(API.endpoints.books, {
          ID: this.id,
          Title: this.newBookFirstName,
          Description: this.newBookLastName,
        })
        .then(() => {
          this.snackbar = true;
          this.showModal = false
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    showModal(newValue) {
      this.showModal = true;
      this.$emit("create-modal-visibility", newValue);
    },
  },
};
</script>
<style>
.dialog-custom {
    padding: 50px;
}
</style>